/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const getunpledgeDummyData = () => {
    return {
        // body: {
        //   Data: [
        //     {
        //       ISINCode: "INE457A01014",
        //       ScripName: "MAHABANK",
        //       UnPledgeQty: 1,
        //     },
        //     {
        //       ISINCode: "INE528G01035",
        //       ScripName: "YESBANK",
        //       UnPledgeQty: 1,
        //     },
        //     {
        //       ISINCode: "INE669E01016",
        //       ScripName: "IDEA",
        //       UnPledgeQty: 4,
        //     },
        //   ],
        //   Message: "Success",
        //   Status: 0,
        // },
        // head: {
        //   responseCode: "5PGUPRequest",
        //   status: "0",
        //   statusDescription: "Success",
        // },
        body: {
            Data: [
                {
                    ISINCode: "INE012A01025",
                    ScripName: "ACC",
                    UnPledgeQty: 2,
                },
                {
                    ISINCode: "INE044A01036",
                    ScripName: "SUNPHARMA",
                    UnPledgeQty: 10,
                },
                {
                    ISINCode: "INE051B01021",
                    ScripName: "VAKRANGEE",
                    UnPledgeQty: 200,
                },
                {
                    ISINCode: "INE118H01025",
                    ScripName: "BSE",
                    UnPledgeQty: 26,
                },
                {
                    ISINCode: "INE208A01029",
                    ScripName: "ASHOKLEY",
                    UnPledgeQty: 105,
                },
                {
                    ISINCode: "INE257A01026",
                    ScripName: "BHEL",
                    UnPledgeQty: 203,
                },
                {
                    ISINCode: "INE501A01019",
                    ScripName: "DEEPAKFERT",
                    UnPledgeQty: 11,
                },
                {
                    ISINCode: "INE549A01026",
                    ScripName: "HCC",
                    UnPledgeQty: 500,
                },
                {
                    ISINCode: "INE618L01018",
                    ScripName: "5PAISA",
                    UnPledgeQty: 100,
                },
                {
                    ISINCode: "INE674K01013",
                    ScripName: "ABCAPITAL",
                    UnPledgeQty: 4,
                },
                {
                    ISINCode: "INE787D01026",
                    ScripName: "BALKRISIND",
                    UnPledgeQty: 10,
                },
            ],
            Message: "Success",
            Status: 0,
        },
        head: {
            responseCode: "5PGUPRequest",
            status: "0",
            statusDescription: "Success",
        },
    };
};
